import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import HomeSafetySection from 'common/Print/components/HomeSafetySection/HomeSafetySection.component';
import { startCase } from 'lodash';
var HomeSafetyAssessmentTemplate = function (props) {
    var _a = props.data, data = _a === void 0 ? [] : _a;
    return (_jsx(Box, { "data-testid": 'homeSafety-template', children: data === null || data === void 0 ? void 0 : data.map(function (section) { return (_jsx(HomeSafetySection, { heading: startCase(section.surveyName), data: section.surveyData }, section.surveyName)); }) }));
};
export default HomeSafetyAssessmentTemplate;
